import React, { FunctionComponent, useMemo } from 'react';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import 'reviews2/feed/review-yeti/reply/labels/ReplyLabels.scss';

export const ReplyHidden: FunctionComponent<{ reply: any }> = ({ reply }) => {
    const { t } = useTranslation('reviews2');
    const isHidden = useMemo(() => reply.properties?.isHidden?.booleanValues?.[0], [reply]);

    if (!isHidden) {
        return null;
    }

    return (
        <span className="reply-hidden">
            <OverlayTrigger overlay={<Tooltip id={reply.document_id}>{t('HIDDEN_TOOLTIP')}</Tooltip>}>
                <i className="icon-eye-slash" />
            </OverlayTrigger>
            {t('REPLY_HIDDEN')}
        </span>
    );
};
